
import Table from "./components/Table";
import TicketTypeGroupModal from './components/TicketTypeGroupModal';

import { getData, deleteData } from './services/api';
import { useSession } from './assets/auth/SessionContext';
import { useEffect, useState } from "react";


const Teams = () => {
    const { session } = useSession();

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [type] = useState("teams")

    async function remove(ref: string) {
        try {
            await deleteData(session, `ticket-type-groups/${ref}`, null)
            return { success: true, message: "Ticket type group removed" };

        } catch (err: any) {
            return { success: false, message: err.message };
        }
    }

    useEffect(() => {

        getData(session, `ticket-type-groups`, null).then(data => {
            setData(data)
            setIsLoading(false);
        }).catch(err => {
            setError(err);
            setIsLoading(false);
        });
    }, []);

    if (isLoading || (!data && !error)) {
        // Render loading indicator or placeholder while data is being fetched
        return (
            <div className="flex">
                <div className="table-container">

                </div>
            </div>
        )
    }

    return (
        <div className="flex">
            <div className="table-container">
                <Table data={data} error={error} type={type} remove={remove} modal={<TicketTypeGroupModal />} />
            </div>
        </div>
    )
}

export default Teams; 